import React, { useRef, useState } from 'react';
import { SendIcon } from '../../../svg';
import Input from './Input';
import { useDispatch, useSelector } from 'react-redux';
import { sendMessage, sendTypedMessage } from '../../../features/chatSlice';
import { ClipLoader } from 'react-spinners';
import EmojiPickerApp from './EmojiPicker';
import { Attachments } from './attachments';
import { Map, Marker } from "pigeon-maps";

function ChatActions(){
    const dispatch =useDispatch();
    const [showPicker,setShowPicker] = useState(false);
    const [showAttachments,setShowAttachments] = useState(false);
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [mapCenter, setMapCenter] = useState([24.7136, 46.6753]);
    const [mapZoom, setMapZoom] = useState(11);
    const [mapPicked, setMapPicked] = useState(null);
    const [locLoading, setLocLoading] = useState(false);
    const {activeConversation,status} = useSelector((state)=>state.chat);
    const {user} = useSelector((state)=>state.user);
    const {token} = user;
    const textRef=useRef();
    const [message,setMessage] = useState("");
    const [loading, setLoading]=useState(false);
    const values={
        message,
        convo_id:activeConversation._id,
        files:[],
        token,
    }
    const SendMessageHandler=async(e)=>{
        e.preventDefault();
        setLoading(true);
        let newMsg=await dispatch(sendMessage(values));
        setMessage("");
        setLoading(false);
    }

    const sendTyped = async (payload) => {
        if (!activeConversation?._id) return;
        setLoading(true);
        await dispatch(sendTypedMessage({ token, convo_id: activeConversation._id, payload }));
        setLoading(false);
    };

    const handleSendContact = async () => {
        const name = window.prompt("اسم جهة الاتصال (اختياري)") || "";
        const phone = window.prompt("رقم الهاتف (اختياري)") || "";
        const email = window.prompt("البريد الإلكتروني (اختياري)") || "";
        if (!name && !phone && !email) return;
        await sendTyped({
            type: "contact",
            contacts: [{ name, phone, email }]
        });
        setShowAttachments(false);
    };

    const handleSendLocation = async () => {
        setShowAttachments(false);
        setShowLocationModal(true);
    };

    const handleSendInteractive = async () => {
        const text = window.prompt("نص الرسالة التفاعلية") || "";
        if (!text.trim()) return;
        await sendTyped({ type: "interactive", text: text.trim() });
        setShowAttachments(false);
    };
    const handleUseCurrentLocation = () => {
        if (!navigator.geolocation) return;
        setLocLoading(true);
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const next = [pos.coords.latitude, pos.coords.longitude];
                setMapCenter(next);
                setMapPicked(next);
                setLocLoading(false);
            },
            () => setLocLoading(false),
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    const handleSendPickedLocation = async () => {
        if (!mapPicked) return;
        await sendTyped({
            type: "location",
            location: { latitude: mapPicked[0], longitude: mapPicked[1] }
        });
        setShowLocationModal(false);
        setMapPicked(null);
    };

    return (
        <>
          <form className="dark:bg-dark_bg_2 h-[60px] w-full flex items-center absolute bottom-0 py-2 px-4 select-none"
              onSubmit={(e)=>SendMessageHandler(e)}
          >
              <div className='w-full flex items-center gap-x-2'>
                  <ul className="flex gap-x-2">
                      <EmojiPickerApp textRef={textRef} message={message} setMessage={setMessage}
                      showPicker={showPicker} setShowPicker={setShowPicker} setShowAttachments={setShowAttachments} />
                      <Attachments
                        showAttachments={showAttachments}
                        setShowAttachments={setShowAttachments}
                        setShowPicker={setShowPicker}
                        onContact={handleSendContact}
                        onLocation={handleSendLocation}
                        onInteractive={handleSendInteractive}
                      />
                  </ul>
                  <Input message={message} setMessage={setMessage} textRef={textRef}/>
                  <button type="submit" className='btn'>
                      {
                          status==="loading" && loading ? <ClipLoader color="#E9EDEF" size={25}/>:

                          (<SendIcon className="dark:fill-dark_svg_1"/>)
                      }
                  </button>
              </div>
          </form>

          {showLocationModal && (
            <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
              <div className="w-full max-w-2xl dark:bg-dark_bg_2 border border-dark_border_1 rounded-xl overflow-hidden">
                <div className="p-3 border-b border-dark_border_1 flex items-center justify-between">
                  <h3 className="text-dark_text_1 font-medium">تحديد الموقع</h3>
                  <button
                    type="button"
                    className="w-8 h-8 rounded-lg hover:bg-dark_hover_1 text-dark_text_2"
                    onClick={() => setShowLocationModal(false)}
                  >
                    ×
                  </button>
                </div>
                <div className="p-3 space-y-3">
                  <div className="h-[360px] w-full rounded-lg overflow-hidden border border-dark_border_1">
                    <Map
                      center={mapCenter}
                      zoom={mapZoom}
                      onBoundsChanged={({ center, zoom }) => {
                        setMapCenter(center);
                        setMapZoom(zoom);
                      }}
                      onClick={({ latLng }) => setMapPicked(latLng)}
                    >
                      {mapPicked && <Marker anchor={mapPicked} width={36} />}
                    </Map>
                  </div>
                  <div className="flex items-center justify-between gap-2">
                    <button
                      type="button"
                      className="px-3 py-2 rounded-lg dark:bg-dark_bg_3 hover:dark:bg-dark_hover_1 border border-dark_border_1 text-dark_text_1 text-sm"
                      onClick={handleUseCurrentLocation}
                      disabled={locLoading}
                    >
                      {locLoading ? "جاري تحديد الموقع..." : "استخدم موقعي الحالي"}
                    </button>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        className="px-3 py-2 rounded-lg dark:bg-dark_bg_3 hover:dark:bg-dark_hover_1 border border-dark_border_1 text-dark_text_1 text-sm"
                        onClick={() => setShowLocationModal(false)}
                      >
                        إلغاء
                      </button>
                      <button
                        type="button"
                        className="px-3 py-2 rounded-lg bg-green_1 hover:bg-green_2 text-white text-sm"
                        onClick={handleSendPickedLocation}
                        disabled={!mapPicked}
                      >
                        إرسال الموقع
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>

    );
}

export default ChatActions;
